import React from 'react';
import { Link } from 'react-router-dom';
import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

const Student = ({ student }) => {
	return (
		<Link
			to={`/users/${student?.id}`}
			className="py-3 px-4 space-y-2 bg-white dark:bg-neutral-800 rounded-lg hover:ring focus:ring ring-amber-500 cursor-pointer transition-all"
		>
			<Avatar
				alt={student?.fullName}
				src={student?.avatar}
			/>

			<Title
				title={student?.fullName}
				subtitle={student?.status}
				className="flex-1"
			/>

			<Show if={student.grade?.id}>
				<Pill
					name={student?.grade?.title}
				/>
		
				<Pill
					name={`${DayJs(student?.grade?.startDate).format('D. MMMM, YYYY')} - ${DayJs(student?.grade?.endDate).format('D. MMMM, YYYY')}`}
				/>
		
				<Pill
					theme="success"
					name={student?.grade?.state}
				/>
			</Show>
		</Link>
	);
};

export default Student;
